// Complete Romanian color variant mappings
const colorVariantMap = {
  // Blue variations
  'albastra': 'albastru',
  'albastre': 'albastru',
  'albastră': 'albastru',
  'blue': 'albastru',
  
  // White variations  
  'alba': 'alb',
  'albe': 'alb',
  'albă': 'alb',
  'white': 'alb',
  
  // Black variations
  'negre': 'negru',
  'negri': 'negru',
  'neagra': 'negru',
  'neagră': 'negru',
  'black': 'negru',
  
  // Transparent variations
  'transparenta': 'transparent',
  'transparente': 'transparent',
  'transparentă': 'transparent',
  
  // Red variations
  'rosie': 'rosu',
  'rosii': 'rosu',
  'roșie': 'rosu',
  'roșii': 'rosu',
  'red': 'rosu',
  
  // Orange variations
  'oranje': 'oranj',
  'portocaliu': 'oranj',
  'portocalie': 'oranj',
  'orange': 'oranj',
  
  // Yellow variations
  'galbena': 'galben',
  'galbene': 'galben',
  'galbenă': 'galben',
  'yellow': 'galben',
  
  // Green variations
  'verzii': 'verde',
  'verzi': 'verde',
  'green': 'verde',
  
  // Purple variations
  'movă': 'mov',
  'violet': 'mov',
  'violete': 'mov',
  'purple': 'mov',
  
  // Pink variations
  'rozul': 'roz',
  'roze': 'roz',
  'pink': 'roz',
  
  // Gray variations
  'grie': 'gri',
  'grii': 'gri',
  'cenusiu': 'gri',
  'gray': 'gri',
  'grey': 'gri',
  
  // Brown variations
  'marou': 'maro',
  'brown': 'maro'
};

function extractColorName(fullText) {
  return fullText.replace(/\d+/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
}

function extractCount(fullText) {
  const match = fullText.match(/\d+/);
  return match ? parseInt(match[0]) : 0;
}

function normalizeColorName(colorName) {
  const cleanName = extractColorName(colorName);
  return colorVariantMap[cleanName] || cleanName;
}

function capitalizeFirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function updateLabelText(label, newText) {
  // Find all text nodes in the label
  const walker = document.createTreeWalker(
    label,
    NodeFilter.SHOW_TEXT,
    null,
    false
  );
  
  const textNodes = [];
  let node;
  while (node = walker.nextNode()) {
    if (node.textContent.trim().length > 0) {
      textNodes.push(node);
    }
  }
  
  // Update the first meaningful text node
  if (textNodes.length > 0) {
    textNodes[0].textContent = newText;
  } else {
    // Fallback: append text after the input
    const input = label.querySelector('input');
    if (input) {
      const textSpan = document.createElement('span');
      textSpan.textContent = newText;
      label.appendChild(textSpan);
    }
  }
}

function processColorFilters() {
  console.log('🎨 Starting clean color filter processing (no numbers)...');
  
  const possibleSelectors = [
    'input[name*="filter.v.option"]',
    'input[name*="color"]',
    'input[type="checkbox"]',
    'input[type="radio"]',
    '.facets input',
    '.collection-filters input',
    '[data-facet] input'
  ];
  
  let allFilterInputs = [];
  
  possibleSelectors.forEach(selector => {
    const inputs = document.querySelectorAll(selector);
    inputs.forEach(input => {
      if (!allFilterInputs.includes(input)) {
        allFilterInputs.push(input);
      }
    });
  });
  
  console.log(`📊 Found ${allFilterInputs.length} filter inputs`);
  
  const colorInputs = allFilterInputs.filter(input => {
    const label = findLabelForInput(input);
    if (!label) return false;
    
    const fullText = label.textContent;
    const cleanText = extractColorName(fullText);
    const isColorRelated = Object.keys(colorVariantMap).includes(cleanText) || 
                          Object.values(colorVariantMap).includes(cleanText) ||
                          ['albastru', 'albastra', 'alb', 'alba', 'albe', 'rosu', 'rosie', 'verde', 'galben', 'negru', 'negre', 'neagra', 'mov', 'roz', 'maro', 'oranj', 'gri', 'transparent', 'transparenta'].some(color => cleanText.includes(color));
    
    if (isColorRelated) {
      console.log(`🎯 Found color input: "${fullText.trim()}" → clean: "${cleanText}"`);
    }
    
    return isColorRelated;
  });
  
  console.log(`🌈 Found ${colorInputs.length} color-related inputs`);
  
  if (colorInputs.length === 0) {
    console.log('❌ No color inputs found.');
    return;
  }
  
  // Group inputs by their parent container
  const containers = {};
  colorInputs.forEach(input => {
    const container = input.closest('.facets__list, .collection-filters, .filter-group, fieldset, .facet-filters__field') || input.parentElement;
    const containerId = container.dataset.facet || container.className || 'default';
    
    if (!containers[containerId]) {
      containers[containerId] = [];
    }
    containers[containerId].push(input);
  });
  
  // Process each container
  Object.keys(containers).forEach(containerId => {
    const inputs = containers[containerId];
    console.log(`📦 Processing container "${containerId}" with ${inputs.length} inputs`);
    
    // Group inputs by normalized color
    const colorGroups = new Map();
    
    // First pass: Group all inputs by normalized color
    inputs.forEach(input => {
      if (input.dataset.processed) return;
      
      const label = findLabelForInput(input);
      if (!label) return;
      
      const originalFullText = label.textContent.trim();
      const cleanColorName = extractColorName(originalFullText);
      const normalizedColor = normalizeColorName(originalFullText);
      const count = extractCount(originalFullText);
      
      if (!colorGroups.has(normalizedColor)) {
        colorGroups.set(normalizedColor, {
          inputs: [],
          totalCount: 0,
          mainInput: null,
          needsNormalization: false
        });
      }
      
      const group = colorGroups.get(normalizedColor);
      group.inputs.push({
        input: input,
        label: label,
        originalText: originalFullText,
        cleanName: cleanColorName,
        count: count,
        isVariant: normalizedColor !== cleanColorName
      });
      group.totalCount += count;
      
      if (normalizedColor !== cleanColorName) {
        group.needsNormalization = true;
      }
      
      console.log(`📋 Grouped "${originalFullText}" → "${normalizedColor}" (variant: ${normalizedColor !== cleanColorName})`);
    });
    
    // Second pass: Process groups that need normalization
    colorGroups.forEach((group, normalizedColor) => {
      if (!group.needsNormalization) {
        console.log(`✅ "${normalizedColor}" doesn't need normalization - keeping as is`);
        return;
      }
      
      console.log(`🔧 Processing group "${normalizedColor}" - needs normalization`);
      
      const mainInputData = group.inputs.find(item => !item.isVariant);
      const variantInputs = group.inputs.filter(item => item.isVariant);
      
      console.log(`📊 Found ${variantInputs.length} variants and ${mainInputData ? 1 : 0} main input for "${normalizedColor}"`);
      
      if (mainInputData) {
        // Update existing main input - REMOVE THE NUMBER
        const mainLabel = mainInputData.label;
        const mainInput = mainInputData.input;
        
        // Update only the text content, preserve the checkbox - NO NUMBERS
        updateLabelText(mainLabel, capitalizeFirst(normalizedColor));
        
        console.log(`📈 Updated main filter "${normalizedColor}" (removed count, was ${group.totalCount})`);
        console.log(`🔍 Main input visibility: ${getComputedStyle(mainInput).display}`);
        
        // Ensure the main input is visible and functional
        mainInput.style.display = '';
        mainInput.style.visibility = 'visible';
        mainInput.style.opacity = '1';
        
        // Hide variant inputs
        variantInputs.forEach(variantData => {
          variantData.input.style.display = 'none';
          variantData.label.style.display = 'none';
          variantData.input.dataset.processed = 'true';
          console.log(`👁️ Hidden variant: "${variantData.originalText}"`);
        });
        
        // Set up event listener for main input
        if (!mainInput.dataset.eventAttached) {
          mainInput.addEventListener('change', function() {
            console.log(`🔥 Main filter "${normalizedColor}" clicked: ${this.checked}`);
            
            variantInputs.forEach(variantData => {
              variantData.input.checked = this.checked;
              variantData.input.dispatchEvent(new Event('change', { bubbles: true }));
              variantData.input.dispatchEvent(new Event('input', { bubbles: true }));
              console.log(`🔄 Updated variant "${variantData.originalText}": ${this.checked}`);
            });
            
            setTimeout(() => {
              document.dispatchEvent(new CustomEvent('facet:changed'));
              document.dispatchEvent(new Event('change', { bubbles: true }));
              
              const form = this.closest('form');
              if (form) {
                form.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }, 10);
          });
          
          mainInput.dataset.eventAttached = 'true';
          console.log(`✅ Event handler attached to main filter "${normalizedColor}"`);
        }
        
      } else {
        // Create new main input from template - NO NUMBERS
        console.log(`➕ No main input found for "${normalizedColor}" - creating one`);
        
        const templateData = group.inputs[0];
        const templateInput = templateData.input;
        const templateLabel = templateData.label;
        
        // Clone the entire container structure
        const mainContainer = templateLabel.parentElement;
        const newContainer = mainContainer.cloneNode(true);
        
        // Find the input and label in the cloned structure
        const mainInput = newContainer.querySelector('input');
        const mainLabel = newContainer.querySelector('label') || newContainer;
        
        // Update the label text - NO NUMBERS
        updateLabelText(mainLabel, capitalizeFirst(normalizedColor));
        
        // Configure main input
        mainInput.dataset.normalizedColor = normalizedColor;
        mainInput.dataset.isMainFilter = 'true';
        mainInput.id = `normalized_${normalizedColor.replace(/\s+/g, '_')}_${Date.now()}`;
        mainInput.checked = false;
        
        // Ensure visibility
        mainInput.style.display = '';
        mainInput.style.visibility = 'visible';
        mainInput.style.opacity = '1';
        
        console.log(`🔍 Created input visibility: ${getComputedStyle(mainInput).display}`);
        console.log(`🔍 Created clean label: "${capitalizeFirst(normalizedColor)}" (total count was ${group.totalCount})`);
        
        // Insert the new container before the first variant
        templateLabel.parentElement.parentNode.insertBefore(newContainer, templateLabel.parentElement);
        
        // Hide all variant inputs
        group.inputs.forEach(variantData => {
          variantData.input.style.display = 'none';
          variantData.label.style.display = 'none';
          variantData.input.dataset.processed = 'true';
          console.log(`👁️ Hidden variant: "${variantData.originalText}"`);
        });
        
        // Set up event handler
        mainInput.addEventListener('change', function() {
          console.log(`🔥 Created main filter "${normalizedColor}" clicked: ${this.checked}`);
          
          group.inputs.forEach(variantData => {
            variantData.input.checked = this.checked;
            variantData.input.dispatchEvent(new Event('change', { bubbles: true }));
            variantData.input.dispatchEvent(new Event('input', { bubbles: true }));
            console.log(`🔄 Updated variant "${variantData.originalText}": ${this.checked}`);
          });
          
          setTimeout(() => {
            document.dispatchEvent(new CustomEvent('facet:changed'));
            document.dispatchEvent(new Event('change', { bubbles: true }));
            
            const form = this.closest('form');
            if (form) {
              form.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }, 10);
        });
        
        console.log(`✅ Created clean main filter "${normalizedColor}" (combined count: ${group.totalCount})`);
      }
    });
  });
  
  console.log('✨ Clean color filter processing complete (numbers removed)!');
}

function findLabelForInput(input) {
  try {
    return input.closest('label') || 
           document.querySelector(`label[for="${input.id}"]`) ||
           input.nextElementSibling ||
           input.previousElementSibling ||
           (input.parentElement ? input.parentElement.querySelector('span, .facet-checkbox__text, .facet-label') : null);
  } catch (e) {
    console.warn('Error finding label for input:', e);
    return null;
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', function() {
  console.log('🚀 DOM Content Loaded - Starting clean color normalization (no numbers)');
  setTimeout(processColorFilters, 500);
});

// Handle dynamic content
document.addEventListener('shopify:section:load', function() {
  console.log('🔄 Shopify section loaded - Re-processing filters');
  setTimeout(processColorFilters, 100);
});

// Watch for changes
const observer = new MutationObserver(function(mutations) {
  let shouldReprocess = false;
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length > 0) {
      mutation.addedNodes.forEach(node => {
        try {
          if (node.nodeType === 1 && (
            node.matches && (
              node.matches('.facets__list, .collection-filters, .filter-group') ||
              node.querySelector('.facets__list, .collection-filters, input[type="checkbox"]')
            )
          )) {
            shouldReprocess = true;
          }
        } catch (e) {
          // Ignore errors
        }
      });
    }
  });
  
  if (shouldReprocess) {
    console.log('🔄 DOM changes detected - Re-processing filters');
    setTimeout(processColorFilters, 50);
  }
});

const targetNode = document.querySelector('main, #MainContent, .collection, body');
if (targetNode) {
  observer.observe(targetNode, { 
    childList: true, 
    subtree: true 
  });
}

window.addEventListener('load', function() {
  console.log('🪟 Window loaded - Final attempt at processing filters');
  setTimeout(processColorFilters, 1000);
});
